import { gql } from '@apollo/client'

import { DebitCardsTable } from 'components/CardsView/components/CardsTable/DebitCardsTable/DebitCardsTable'

export const ActivateDebitCard = gql`
  mutation ActivateDebitCard($input: ActivateDebitCardInput!) {
    activateDebitCard(input: $input) {
      ... on DebitCardV2 {
        productType
        accessibleProfile
        ...DebitCardsTableDebitCardV2Fragment
      }
      ... on ActivateDebitCardError {
        __typename
        error
      }
    }
  }

  ${DebitCardsTable.fragments.DebitCardV2}
`
